export default __webpack_public_path__ + "img/membership_banner-f0c8fba4e1c3bc5fe00e769865244dfb.jpg";